import React from "react";
import { Paper, Card, CardTitle } from "material-ui";
import SubmitForm from "../components/SubmitForm";

export default () => (
  <div>
    <Paper className={"paper-container"}>
      <p>
        The gridSolvate program predicts the distribution of hydration sites
        within proteins. Input data is provided as an atomistic model of a
        protein structure in PDB-like format.
      </p>
      <p>
        The output includes pdb files containing coordinates of bound water
        molecules with estimates of their binding free energies.
      </p>
    </Paper>
    <br />
    <Card>
      <CardTitle title="Prepare a job:" />
      <SubmitForm />
    </Card>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/main.js